<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import './assets/css/default.css'
  export default {
    name: "App",
  }
</script>

<style>
  #app {
    width: 100%;
    height: 100%;
  }
</style>
